import React from "react";
import PropTypes from "prop-types";
import { Radio } from "antd";

import { SelectorInfoPopover } from "../../";

const InputSelectorSingle = ({
  options,
  selectedValue,
  disabledValues,
  onChange
}) => {
  const onChangeOption = event => {
    onChange(event.target.value);
  };

  return (
    <Radio.Group onChange={onChangeOption} value={selectedValue}>
      {options &&
        options.map(o => (
          <Radio
            style={{ display: "block" }}
            value={o.value}
            key={o.value}
            disabled={disabledValues.indexOf(o.value) >= 0}
          >
            {o.text ? o.text : o.value}{" "}
            {o.description && <SelectorInfoPopover text={o.description} />}
          </Radio>
        ))}
    </Radio.Group>
  );
};

InputSelectorSingle.propTypes = {
  options: PropTypes.array.isRequired,
  selectedValue: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  disabledValues: PropTypes.array,
  onChange: PropTypes.func.isRequired
};

export default InputSelectorSingle;



// WEBPACK FOOTER //
// ./src/views/components/input_selector/input_selector_single/InputSelectorSingle.jsx